import { ContainerProps as MuiContainerProps } from '@mui/material/Container/Container';
import { forwardRef } from 'react';
import MuiContainer from '@mui/material/Container';

export interface ContainerProps extends MuiContainerProps {
  horizontalScroll?: boolean;
}

const Container = forwardRef<HTMLDivElement, ContainerProps>((props, ref) => {
  return <MuiContainer ref={ref} {...props} />;
});

Container.displayName = 'Container';
export default Container;
